import React, { useEffect, useState } from 'react'
import { GET_CPDP_SCORE_CATEGORY, GET_CPDP_SCORE_SEMESTER } from '../../../Templates/components/APIs';
import { Error404 } from '../../../Library/LoaderPage';
import LoadingBtn from '../../Widgets/LoadingBtn';
import { AlertNotif } from '../../../Library/AlertNotif';
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import { CPDPSemester } from './CPDPSemester';
import { CPDPCategories } from './CPDPCategories';
import { Card } from 'react-bootstrap';

export function CPDPInfo({ studentid, cpdp_points, max_points }) {
    const percentage = (cpdp_points / max_points) * 100;
    const remainingQuota = max_points - cpdp_points;
    const is_pass = cpdp_points >= max_points ? true : false;

    const [cpdp, setCPDP] = useState({ loading: false, data: [], message: "" });
    const ReloadData = async () => {
        setCPDP({ loading: true, data: [], message: "" });
        const param = { studentid };
        const [r_semester, r_category] = await Promise.all([
            GET_CPDP_SCORE_SEMESTER(param),
            GET_CPDP_SCORE_CATEGORY(param)
        ]);

        let data_semester = [];
        if (r_semester.data && Object.values(r_semester.data).length > 0) {
            data_semester = r_semester.data?.dt || [];
        }

        let data_categories = [];
        if (r_category.data && Object.values(r_category.data).length > 0) {
            data_categories = r_category.data?.categories || [];
        }
        setCPDP({ loading: false, data: { semester: data_semester, categories: data_categories }, message: r_category.message || r_semester.message || "" });
    }

    useEffect(() => {
        try {
            ReloadData();
        } catch (error) {
            setCPDP({ loading: false, data: [], message: error.message });
        }
    }, [studentid])

    try {

        return (
            <div>
                <div className="row">
                    <div className="col-3">
                        <Card>
                            <Card.Body className='px-3 py-3'>
                                <div className='mb-3'>
                                    <span className="d-block font-weight-bolder text-dark h3">
                                        CPDP Points Progress
                                    </span>
                                    <span className="text-muted mt-3 font-weight-bold font-size-sm">
                                        {cpdp_points} of {max_points} points collected
                                    </span>
                                </div>
                                <div className="px-8">
                                    <CircularProgressbar
                                        value={percentage}
                                        text={`${cpdp_points}/${max_points}`}
                                        strokeWidth={10}
                                        styles={buildStyles({
                                            pathColor: "#369AFF",
                                            textColor: "#000",
                                            textSize: 20,
                                        })}
                                    />
                                </div>
                            </Card.Body>
                        </Card>
                    </div>

                    {cpdp.loading ? <div className="col-9"><LoadingBtn /></div> :
                        cpdp.message ? <div className="col-9"><AlertNotif messages={cpdp.message} color="danger" /></div> :
                            Object.values(cpdp.data).length > 0 ? (
                                <>
                                    <div className="col-9">
                                        <CPDPSemester data={cpdp.data?.semester || []} />
                                    </div>
                                    <div className="col-12 my-5">
                                        <CPDPCategories data={cpdp.data?.categories || []} />
                                    </div>
                                </>
                            ) : <div className="col-9"><Error404 /></div>}
                </div>
            </div>
        )
    } catch (error) {
        return <AlertNotif message={error.message} color="danger" />
    }
}
